export default "__VITE_ASSET__B59Y0mKF__"